export const EnvironmentalMetrics = [
  {value: '1', label: 'Scope 1 GHG Emissions'},
  {value: '2', label: 'Scope 2 GHG Emissions'},
  {value: '15', label: 'Scope 1 + 2 GHG Emissions'},
  {value: '3', label: 'Scope 3 GHG Emissions'},
  {value: '9', label: 'Scope 1 GHG Physical Emission Intensity'},
  {value: '10', label: 'Scope 2 GHG Physical Emission Intensity'},
  {value: '11', label: 'Scope 3 GHG Physical Emission Intensity'},
  {value: '12', label: 'Scope 1 GHG Economic Emission Intensity'},
  {value: '13', label: 'Scope 2 GHG Economic Emission Intensity'},
  {value: '14', label: 'Scope 3 GHG Economic Emission Intensity'},
  {value: '17', label: 'Scope 1+2 Physical Emission Intensity'},
  {value: '18', label: 'Scope 1+2 Economic Emission Intensity'},
  {value: '19', label: 'Scope 1+2+3 Emissions'},

  {value: '4', label: 'Energy Consumption (Renewable/Non-renewable)'},
  {value: '5', label: 'Water Consumption'},
  {value: '6', label: 'Water Recycling Rate'},
  {value: '7', label: 'Waste Management (Hazardous/Non-Hazardous)'},
  {value: '8', label: 'Biodiversity Impact Management'},
  {value: '16', label: 'Total Revenue'}
];

export const SocialMetrics = [
  {value: '1', label: 'Workforce Diversity'},
  {value: '2', label: 'Board Diversity'},
  {value: '3', label: 'Skill Upgradation %'},
  {value: '4', label: 'Employee Turnover Rate'},
  {value: '5', label: 'Occupational Health & Safety (Injury Rates)'},
  {value: '6', label: 'Human Rights Policy Implementation %'},
  {value: '7', label: 'Supply Chain Social Assessments'},
  {value: '8', label: 'Community Development and CSR Initiatives'}
];

export const GovernanceMetrics = [
  {value: '3', label: 'Board Independence'},
  {value: '1', label: 'ESG Oversight by Board'},
  {value: '4', label: 'Executive Compensation Linkage to ESG'},
  {value: '5', label: 'Whistleblower Mechanism'},
  {value: '2', label: 'Anti-Bribery/Anti-Corruption Policies'},
  {value: '6', label: 'ESG Risk Management Framework'},
  {
    value: '7',
    label: 'Transparency in ESG Reporting and External Assurance'
  }
];

export const StrategyMetrics = [
  {value: '1', label: 'Decarbonization Strategy'},
  {value: '2', label: 'Company Targets & Climate Scenario / Pathway'},
  {value: '3', label: 'Current Frameworks & Ratings'},
  {value: '4', label: 'ESG Strategy'}
];
